import { Grid as BaseGrid, styled } from '@mui/material'

export const Grid = styled(BaseGrid)`
  grid-area: error;
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: 100%;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  margin: auto 0 auto auto;
  padding: 5px;
`
